import { apiFetchWeb } from "@/hooks/apiFetchWeb"

export const websiteAttributeService = {
  getAttributes: async (signal?: AbortSignal) =>
    apiFetchWeb(`website/attributes`, {
      signal,
    }),
}
